import * as firestore from "firebase/firestore";
import { database } from "../firebaseConfig";

class FluxoRealtime {
    private collection = firestore.collection(database, "Fluxo-State");

    updateFluxoState(idState: string, newState: firestore.UpdateData<firestore.DocumentData>) {
        const docRef = firestore.doc(this.collection, idState);
        return firestore.updateDoc(docRef, newState);
    }

    subscribeToFluxo(idFluxo: string, callback: (data: firestore.DocumentData[]) => void) {
        const query = firestore.query(this.collection, firestore.where("idFluxo", "==", idFluxo));

        return firestore.onSnapshot(query, async (snapshot) => {
            const changes = snapshot.docChanges().map(change => ({ type: change.type, data: change.doc.data() }));
            callback(changes);
        });
    }
}

export default FluxoRealtime;